import type { ReceiverInput } from "./ReceiverInput"
import type { ReceiverOutput } from "./ReceiverOutput"

export type MessageRouter<T, R> = (
  request: ReceiverInput<T>
) => ReceiverOutput<R>
